import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=3b6b5ae8&scoped=true&lang=pug&"
import script from "./EventList.vue?vue&type=script&lang=ts&"
export * from "./EventList.vue?vue&type=script&lang=ts&"
import style0 from "./EventList.vue?vue&type=style&index=0&id=3b6b5ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b5ae8",
  null
  
)

export default component.exports